import React, { useState, useEffect } from "react";
import * as yup from "yup";
import { useLocation } from "react-router-dom";
import queryString from "query-string";
import { Report, TonnageDisclaimer } from "../../../shared";
import { Fragment } from "react";
import { Link } from "react-router-dom";

//const schema = yup.object();
const schema = yup.object({
   multiStatus: yup.string().required("Status is required."),

 }); 

function TransporterReport() {
  const location = useLocation();
  const params = queryString.parse(location.search);
  const searchOnInit = Object.keys(params).length > 0 ? true : false;
  const [backToUrl, setBackToUrl] = useState("/reports");
  const [pageTitle, setPageTitle] = useState(
    "Search for a Transporter Profile"
  );
  const [initialFormValues, setInitialFormValues] = useState({
    regId: params && params.regId ? params.regId : "",
    name: params && params.name ? params.name : "",
    county: params && params.county ? params.county : "",
    city: params && params.city ? params.city : "",
    zip: params && params.zip ? params.zip : "",
    multiStatus: params && params.status ? params.status : [],
    regFromDate: params && params.regFromDate ? params.regFromDate : "",
    regToDate: params && params.regToDate ? params.regToDate : ""
/*     status:
    params && params.status
      ? [{ value: params.status, label: params.status }]
      : [], */
  });
  const [apiEndpoint, setApiEndpoint] = useState(
    "api/v1/hwts/search/transporters"
  );

  const formConfig = [
    // {
    //   name: "keyword",
    //   config: {
    //     label: "Keyword",
    //     col: "md",
    //     colWidth: "3",
    //     placeholder: "",
    //     type: "text"
    //   }
    // },
    {
      name: "regId",
      config: {
        label: "Registration ID",
        col: "md",
        colWidth: "3",
        placeholder: "",
        type: "text",
      },
    },
    {
      name: "name",
      config: {
        label: "Transporter Name",
        col: "md",
        colWidth: "3",
        placeholder: "",
        type: "text",
      },
    },
    {
      name: "county",
      config: {
        label: "County",
        col: "md",
        validate: true,
        colWidth: "3",
        placeholder: "Select a County",
        type: "select3",
        apiEndpoint: "api/v1/hwts/search/counties",
        hasApi: true,
      },
    },
    {
      name: "city",
      config: {
        col: "md",
        colWidth: "3",
        label: "City",
        placeholder: "Select a City",
        type: "select3",
        apiEndpoint: "api/v1/hwts/search/cities",
        hasApi: true,
        customStyles: {
          control: (base) => ({
            ...base,
            borderRadius: 0,
            height: "10px",
            lineHeight: 1.3,
            fontSize: "1rem",
          }),
          menu: (base) => ({
            ...base,
            width: "300px",
          }),
        },
      },
    },
    {
      name: "zip",
      config: {
        label: "Zip Code",
        col: "md",
        colWidth: "3",
        placeholder: "",
        type: "text",
      },
    },
    {
      name: "multiStatus",
      config: {
        label: "Registration Status",
        col: "md",
        colWidth: "3",
        placeholder: "",
        type: "multi-select",
        //default: "Active",
        //type: "select3",
        data: [
          { label: "All Statuses", value: "Active,Denied,Expired,Revoked,Suspended,Voluntary"},
 //         { label: "All Status", value: ""},
          { label: "Active", value: "Active" },
          { label: "Denied", value: "Denied" },
          { label: "Expired", value: "Expired" },
          { label: "Revoked", value: "Revoked" },
          { label: "Suspended", value: "Suspended" },
          { label: "Voluntary", value: "Voluntary" },
        ],
      },
      },
      {
          name: "regFromDate",
          config: {
              label: "Registration From Date",
              col: "md",
              colWidth: "3",
              placeholder: "",
              type: "date",
          }
      },
      {
          name: "regToDate", config: {
              label: "Registration To Date",
              col: "md",
              colWidth: "3",
              placeholder: "",
              type: "date",
          }
      }
  ];

  const customGridCells = [
    {
      columnName: "Registration_ID",
      cellRenderer: function (params) {
        if (params.value != null) {
          return (
            `<a href="/reports/transporter/${params.value}" target="_blank">` +
            params.value +
            "</a>"
          );
        }
      },
    },
  ];

  return (
    <Fragment>
      <Report
        breadcrumb={[
          { name: "HWTS Reports", url: "/reports", active: false },
          { name: "Transporters", url: "", active: true },
        ]}
        backToUrl={backToUrl}
        pageTitle={pageTitle}
        initialFormValues={initialFormValues}
        schema={schema}
        formConfig={formConfig}
        apiEndpoint={apiEndpoint}
        customGridCells={customGridCells}
        searchOnInit={searchOnInit}
      />
      <div className="container">
        <TonnageDisclaimer />
      </div>
    </Fragment>
  );
}

export default TransporterReport;
